import Layout from '../templates/Layout';

// TODO: This is a temporary placeholder. This is to be implemented later
const NotFound = () => {
  return (
    <Layout>
      Page Not Found
      <br />
      Available pages on sidebar:
      <ul>
        <li>Workpacks</li>
        <li>Scaffolds</li>
        <li>Liftplans</li>
        <li>Materials</li>
      </ul>
    </Layout>
  );
};

export default NotFound;
